import React, { useState } from 'react';
import { Header } from '@hz-design-system/web-ui';
import type { THeaderConfig } from '@hz-design-system/web-ui/lib/types/THeaderConfig';
import { trackGAEvent } from '../../utils/gaTracking';
import useSearch from '../../hooks/useSearch';
import useCategories from '../../hooks/useCategories';

type THeaderAppProps = {
  headerConfig: THeaderConfig;
};

function HeaderApp({ headerConfig }: THeaderAppProps) {
  const searchBar = headerConfig.searchBar;
  const defaultCategoryOptions = (searchBar?.categoryOptions ?? []) as unknown as TCategoryOption[];

  const [searchQuery, setSearchQuery] = useState<TSearchQuery>({
    categoryId: Number(searchBar?.categoryValue) || 0,
    postcode: searchBar?.postcodeValue || '',
    radius: Number(searchBar?.distanceValue) || 0,
  });
  const categories = useCategories(defaultCategoryOptions, searchQuery.categoryId);

  useSearch(setSearchQuery);

  const processedHeaderConfig = {
    ...headerConfig,
    searchBar: searchBar
      ? {
          ...searchBar,
          categoryOptions: categories,
        }
      : searchBar,
  } as THeaderConfig;

  return <Header headerConfig={processedHeaderConfig} trackGAEvent={trackGAEvent} />;
}
export default HeaderApp;
